var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRailsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Ruby On Rails",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 402c34-163 125-282 321-288v15c-121 33-180 118-159 273H98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 359l-4 27 30 13 1-27zM88 283l-13 36 34 10 13-35zM158 175l-25 27 31 23 25-30zM250 109l-27 19 21 24 28-18zM325 99l6 18 28-7-6-16zM359 169l13 20 16-15-7-16zM320 196l-17 18 23 27 12-19zM283 274l-8 25 31 18 1-27z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailsIcon);
export default __webpack_public_path__ + "static/media/rails-icon.39f203820711fd9200c4b134c3386a67.svg";
export { ForwardRef as ReactComponent };